import api from '@shared/services/api';
import type { LoginResponse, RegisterResponse } from '@/types/api';

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { email, password }),

  register: (data: {
    email: string;
    password: string;
    password_confirmation: string;
    role: string;
    first_name: string;
    last_name: string;
    phone?: string;
  }) => api.post<RegisterResponse>('/auth/register', data),

  logout: () => api.post('/auth/logout'),

  me: () => api.get('/auth/me'),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),

  resetPassword: (data: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
  }) => api.post('/auth/reset-password', data),

  sendPhoneOtp: (phone: string) =>
    api.post('/auth/verify-phone/send-otp', { phone }),

  confirmPhoneOtp: (phone: string, otp: string) =>
    api.post('/auth/verify-phone/confirm', { phone, otp }),

  verifyEmail: (id: string, hash: string) =>
    api.post('/auth/verify-email', { id, hash }),

  resendVerificationEmail: () => api.post('/auth/verify-email/resend'),
};
